type PencomFooterProps = {
  floating?: boolean;
};

export const PencomFooter = (props: PencomFooterProps): null => {
  void props;
  return null;
};
